import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { userPrivileges } from '../../../apollo/cache.js';
import { useReactiveVar } from '@apollo/client';
import CustomizationPage from '../../appraisalView/components/CustomizationPage.js';
import IndustryReportsNavigationPage from '../../industryReports/components/IndustryReportsNavigationPage.js';
import BaselineReportsPage from '../../industryReports/components/BaselineReportsPage.js';
import AppraisalViewPage from '../../appraisalView/components/AppraisalViewPage.js';
import PrivilegeNames from '../../../constants/privilegeNames.js';
import NotFoundPage from '../../notFound/NotfoundPage.js';
import UserManagementPage from '../../userManagement/components/UserManagementPage.js';
import AssignLicensePage from '../../userManagement/components/assignLicense/AssignLicensePage.js';
import ReleaseNotesPage from '../../releaseNotes/components/ReleaseNotesPage.js';
import EditLicensePage from '../../userManagement/components/editLicense/EditLicensePage.js';
import ResourcePage from '../../resources/components/ResourcesPage.js';
import SubmitFeedbackPage from '../../feedback/components/SubmitFeedbackPage.js';
import NoPermissionsPage from '../../unauthorized/NoPermissionsPage.js';
import StrengthsAndChallengesPage from '../../strengthsAndChallenges/components/StrengthsAndChallengesPage.js';
import LandingPageWrapper from '../components/LandingPageWrapper.js';
import AggregatePerformanceReport from '../../aggregatePerformanceReport/components/AggregatePerformanceReport.js';
import DataCorrelationsPage from '../../dataCorrelations/components/DataCorrelationsPage.js';

const RoutesForIndustryOnly = () => {
  const privileges = useReactiveVar(userPrivileges);
  if (!privileges || !privileges.length) {
    return null;
  }

  return (
    <Routes>
      <Route path='/industry-reports'>
        {privileges.includes(PrivilegeNames.IndustryReports) && (
          <Route path='' element={<LandingPageWrapper page={IndustryReportsNavigationPage} />} />
        )}
        {privileges.includes(PrivilegeNames.BaseLine) && (
          <Route path='baseline' element={<BaselineReportsPage />} />
        )}
        {privileges.includes(PrivilegeNames.Customization) && (
          <Route path='customization' element={<CustomizationPage />} />
        )}
        {privileges.includes(PrivilegeNames.AppraisalView) && (
          <Route path='customization/appraisal-view' element={<AppraisalViewPage />} />
        )}
        {privileges.includes(PrivilegeNames.StrengthsAndChallenges) && (
          <Route path='strengths-challenges' element={<StrengthsAndChallengesPage />} />
        )}
        {privileges.includes(PrivilegeNames.AggregatePerformanceReport) && (
          <Route path='aggregate-performance-report' element={<AggregatePerformanceReport />} />
        )}
        {privileges.includes(PrivilegeNames.DataCorrelations) && (
          <Route path='data-correlations' element={<DataCorrelationsPage />} />
        )}
      </Route>
      {privileges.includes(PrivilegeNames.UserManagement) && (
        <Route path='/user-management'>
          <Route path='' element={<UserManagementPage />} />
          <Route path='assign-license' element={<AssignLicensePage />} />
          <Route path='edit-license' element={<EditLicensePage />} />
        </Route>
      )}
      {privileges.includes(PrivilegeNames.Resources) && (
        <Route path='/resources' element={<ResourcePage />} />
      )}
      {privileges.includes(PrivilegeNames.ReleaseNotes) && (
        <Route path='/release-notes' element={<ReleaseNotesPage />} />
      )}
      {privileges.includes(PrivilegeNames.SubmitFeedback) && (
        <Route path='/submit-feedback' element={<SubmitFeedbackPage />} />
      )}
      <Route path='/' element={<Navigate to='/industry-reports' replace />} />
      <Route path='/page-not-found' element={<NotFoundPage />} />

      <Route path='/permissions' element={<NoPermissionsPage />} />
      <Route path='*' element={<Navigate to='/page-not-found' replace />} />
    </Routes>
  );
};

export default RoutesForIndustryOnly;
